{
  "taskDetail": {
    "backToTasks": "Back to Tasks",
    "markAsCompleted": "Mark as completed",
    "completedOn": "Completed on",
    "status": {
      "completed": "Completed",
      "dueSoon": "Due Soon",
      "overdue": "Overdue",
      "active": "Active",
      "onHold": "OnHold"
    },
    "card": {
      "title": "Task Details",
      "description": "Task Description"
    },
    "fields": {
      "taskId": "Task ID",
      "dueDate": "Due Date",
      "assignee": "Assignee",
      "unassigned": "Unassigned",
      "createDate": "Create Date",
      "closeDate": "Close Date",
      "orderId": "Order ID",
      "lastUpdate": "Last Update:",
      "holdUntil": "Hold Until:"
    },
    "buttons": {
      "reassignTask": "Reassign Task",
      "deleteTask": "Delete Task",
      "putOnHold": "Put On Hold"
    },
    "putOnHold": {
      "title": "Put Task On Hold",
      "info": "Task will be hidden from active queues until selected date.",
      "holdUntilLabel": "Hold Until",
      "helperText": "Please select a future date.",
      "validationRulesTitle": "Validation Rules",
      "rules": {
        "futureDate": "Must be a future date.",
        "slaDate": "Must be on or before SLA Date:",
        "reprojectionDate": "Must be on or before Reprojection Date:",
        "oneDay": "Must be within 1 day from today.",
        "notApplicable": "N/A"
      },
      "cancel": "Cancel",
      "save": "Save",
      "successMessage": "Task has been placed on hold successfully",
      "errorMessage": "Unable to place task on hold. Please try again."
    }
  }
}
